import { createAdvancedOrderProduct } from '../global'
import { initSwiperGallery } from './gallery'
import { isMobile, createSwiperProductBlocks, _t, findParameter } from '../base'

function moveAddDetailElements() {
    $("<div class = 'cart-details'>").insertBefore('.p-to-cart-block')
    $('.p-final-price-wrapper').appendTo('.cart-details')
    $('<div class = availability-wrapper>').appendTo('.p-data-wrapper .price-additional')

    $('.p-data-wrapper .availability-wrapper').append($('.detail-parameters td:has(.availability-label)'))

    $('.shipping-options-layout').appendTo('.p-final-price-wrapper')

    $('.p-data-wrapper .p-code').insertBefore('.cart-details')

    $('.p-short-description').insertAfter('.p-detail-inner-header h1')
}

function getProductPriceWithoutVat() {
    const priceAdditionalEl = $('.p-data-wrapper .price-additional')
    const clonedEl = priceAdditionalEl.clone()

    clonedEl.find('.availability-wrapper').remove()

    const priceText = clonedEl.text().trim()

    return priceText
}

function addImageAndPriceToAdvancedOrderDetail() {
    const image = $('.p-image img').attr('src')
    const price = $('.price-final-holder:not(.no-display').text()
    const priceNoVat = getProductPriceWithoutVat()
    const name = getShoptetDataLayer('product').name
    const availability = $('.availability-wrapper .availability-label').prop('outerHTML')

    createAdvancedOrderProduct({ image, price, name, availability, priceNoVat })
}

function brandImage() {
    const brandWrapper = document.querySelector('.brand-wrapper')

    if (brandWrapper) {
        brandWrapper.childNodes[0].textContent = _t('detail.brand')
    }

    $('#manufacturerDescription img')
        .attr('src', function (_, src) {
            return src.replace('/thumb/', '/orig/')
        })
        .appendTo('.brand-wrapper-manufacturer-name a')
}

function productExpirationDate() {
    const productId = $('.p-data-wrapper .p-code td span').text()

    console.log(productId)

    // Find expiration date from description
    let expirationDate = null
    const descriptionParagraphs = $('.p-short-description p')

    descriptionParagraphs.each(function () {
        const text = $(this).text()
        if (text.toLowerCase().includes('expirace:')) {
            expirationDate = text.trim()
        }
    })

    if (expirationDate) {
        // Get existing data or initialize empty array
        const existingData = JSON.parse(localStorage.getItem('productsExpirationData') || '[]')

        // Create new product entry
        const newProduct = {
            id: productId,
            expirationDate: expirationDate,
        }

        // Update or add the product data
        const existingIndex = existingData.findIndex((item) => item.id === productId)
        if (existingIndex >= 0) {
            existingData[existingIndex] = newProduct
        } else {
            existingData.push(newProduct)
        }

        // Save back to localStorage
        localStorage.setItem('productsExpirationData', JSON.stringify(existingData))
    }
}

function addExpirationDateToProduct() {
    const expirationDate = findParameter(_t('detail.expirationDate'))

    if (expirationDate) {
        console.log('Found expiration date from parameter:', expirationDate)
        $(
            `<div class="expiration-date">${_t('detail.expirationDate')}: ${expirationDate}</div>`
        ).insertBefore('.cart-details')
    }
}

function addExpirationDateFromDescription() {
    const descriptionParagraphs = $('.p-short-description p')
    let expirationDate = null

    descriptionParagraphs.each(function () {
        const text = $(this).text()
        if (text.toLowerCase().includes('expirace')) {
            expirationDate = text.trim()
            $(this).hide()
            return false
        }
    })

    if (expirationDate) {
        $(`<div class="expiration-date">${expirationDate}</div>`).insertBefore('.cart-details')
    }
}

function detailTextChanges() {}

export function initDetail() {
    // Add detail elements
    moveAddDetailElements()
    detailTextChanges()
    addExpirationDateToProduct()
    addExpirationDateFromDescription()

    // Gallery
    initSwiperGallery()

    // Products slider
    createSwiperProductBlocks()

    // mezikošík
    addImageAndPriceToAdvancedOrderDetail()

    // Product expiration date
    document.addEventListener('ShoptetDOMAdvancedOrderLoaded', () => {
        productExpirationDate()
    })

    document.addEventListener('ShoptetSplitVariantParameterChange', () => {
        setTimeout(() => {
            addImageAndPriceToAdvancedOrderDetail()
        }, 100)
    })
}
